<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ 'changePassword.title' | translate }}</h2>
      <button type="button" class="close-button" (click)="onClose()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <form (ngSubmit)="onSubmit()" #passwordForm="ngForm">
        <div class="form-group">
          <label for="oldPassword">{{ 'changePassword.oldPassword' | translate }}</label>
          <input
            type="password"
            id="oldPassword"
            name="oldPassword"
            [(ngModel)]="oldPassword"
            [disabled]="isLoading"
            required
            autocomplete="current-password">
        </div>

        <div class="form-group">
          <label for="newPassword">{{ 'changePassword.newPassword' | translate }}</label>
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            [(ngModel)]="newPassword"
            [disabled]="isLoading"
            required
            autocomplete="new-password">
        </div>

        <div class="form-group">
          <label for="confirmPassword">{{ 'changePassword.confirmPassword' | translate }}</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            [(ngModel)]="confirmPassword"
            [disabled]="isLoading"
            required
            autocomplete="new-password">
        </div>

        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage | translate }}
        </div>

        <div class="success-message" *ngIf="successMessage">
          {{ successMessage | translate }}
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-cancel" (click)="onClose()" [disabled]="isLoading">
            {{ 'changePassword.cancel' | translate }}
          </button>
          <button type="submit" class="btn-submit" [disabled]="isLoading || !passwordForm.form.valid">
            <span *ngIf="!isLoading">{{ 'changePassword.submit' | translate }}</span>
            <span *ngIf="isLoading">{{ 'changePassword.loading' | translate }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
